import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
@Injectable({
  providedIn: 'root',
})
export class CommonServiceService {
  public patients: any = [
    {
      patientName: 'Richard Wilson',
      patient_id: 'P0016',
      apptDate: 'Sat May 23 2020 13:35:47 GMT+0530 (India Standard Time)',
      purpose: 'General',
      type: 'New patient',
      email: 'richard@example.com',
      phone: '+1 923 782 4575',
      amount: 150,
      status: 0,
    },
    {
      patientName: 'Richard Wilson',
      patient_id: 'P0001',
      email: 'richard@example.com',
      apptDate: 'Sat May 23 2020 13:35:47 GMT+0530 (India Standard Time)',
      purpose: 'General',
      type: 'Old patient',
      phone: '+1 828 632 9170',
      amount: 200,
      status: 0,
    },
    {
      patientName: 'Richard Wilson',
      patient_id: 'P0002',
      email: 'richard@example.com',
      apptDate: 'Sat May 23 2020 13:35:47 GMT+0530 (India Standard Time)',
      purpose: 'General',
      type: 'New patient',
      phone: '+1 828 632 9170',
      amount: 350,
      status: 0,
    },
    {
      patientName: 'Richard Wilson',
      email: 'richard@example.com',
      patient_id: 'P0003',
      apptDate: 'Sat May 23 2020 13:35:47 GMT+0530 (India Standard Time)',
      purpose: 'General',
      type: 'New patient',
      amount: 400,
      status: 0,
    },
  ];
  public times: any = [
    {
      display: '12:00 PM',
      value: '12:00:00',
    },
    {
      display: '12:15 PM',
      value: '12:15:00',
    },
    {
      display: '12:30 PM',
      value: '12:30:00',
    },
    {
      display: '12:45 PM',
      value: '12:45:00',
    },
    {
      display: '01:00 PM',
      value: '13:00:00',
    },
    {
      display: '01:15 PM',
      value: '13:15:00',
    },
    {
      display: '01:30 PM',
      value: '13:30:00',
    },
    {
      display: '01:45 PM',
      value: '13:45:00',
    },
    {
      display: '02:00 PM',
      value: '14:00:00',
    },
    {
      display: '02:15 PM',
      value: '14:15:00',
    },
    {
      display: '02:30 PM',
      value: '14:30:00',
    },
    {
      display: '02:45 PM',
      value: '14:45:00',
    },
    {
      display: '03:00 PM',
      value: '15:00:00',
    },
    {
      display: '03:15 PM',
      value: '15:15:00',
    },
    {
      display: '03:30 PM',
      value: '15:30:00',
    },
    {
      display: '03:45 PM',
      value: '15:45:00',
    },
    {
      display: '04:00 PM',
      value: '16:00:00',
    },
    {
      display: '04:15 PM',
      value: '16:15:00',
    },
    {
      display: '04:30 PM',
      value: '16:30:00',
    },
    {
      display: '04:45 PM',
      value: '16:45:00',
    },
    {
      display: '05:00 PM',
      value: '17:00:00',
    },
    {
      display: '05:15 PM',
      value: '17:15:00',
    },
    {
      display: '05:30 PM',
      value: '17:30:00',
    },
    {
      display: '05:45 PM',
      value: '17:45:00',
    },
    {
      display: '06:00 PM',
      value: '18:00:00',
    },
    {
      display: '06:15 PM',
      value: '18:15:00',
    },
    {
      display: '06:30 PM',
      value: '18:30:00',
    },
    {
      display: '06:45 PM',
      value: '18:45:00',
    },
    {
      display: '07:00 PM',
      value: '19:00:00',
    },
    {
      display: '07:15 PM',
      value: '19:15:00',
    },
    {
      display: '07:30 PM',
      value: '19:30:00',
    },
    {
      display: '07:45 PM',
      value: '19:45:00',
    },
    {
      display: '08:00 PM',
      value: '20:00:00',
    },
    {
      display: '08:15 PM',
      value: '20:15:00',
    },
    {
      display: '08:30 PM',
      value: '20:30:00',
    },
    {
      display: '08:45 PM',
      value: '20:45:00',
    },
    {
      display: '09:00 PM',
      value: '21:00:00',
    },
    {
      display: '09:15 PM',
      value: '21:15:00',
    },
    {
      display: '09:30 PM',
      value: '21:30:00',
    },
    {
      display: '09:45 PM',
      value: '21:45:00',
    },
    {
      display: '10:00 PM',
      value: '22:00:00',
    },
    {
      display: '10:15 PM',
      value: '22:15:00',
    },
    {
      display: '10:30 PM',
      value: '22:30:00',
    },
    {
      display: '10:45 PM',
      value: '22:45:00',
    },
    {
      display: '11:00 PM',
      value: '23:00:00',
    },
    {
      display: '11:15 PM',
      value: '23:15:00',
    },
    {
      display: '11:30 PM',
      value: '23:30:00',
    },
    {
      display: '11:45 PM',
      value: '23:45:00',
    },

    {
      display: '12:00 AM',
      value: '00:00:00',
    },
    {
      display: '12:15 PM',
      value: '00:15:00',
    },
    {
      display: '12:30 PM',
      value: '00:30:00',
    },
    {
      display: '12:45 PM',
      value: '00:45:00',
    },
    
    {
      display: '01:00 AM',
      value: '01:00:00',
    },
    {
      display: '01:15 AM',
      value: '13:15:00',
    },
    {
      display: '01:30 AM',
      value: '01:30:00',
    },
    {
      display: '01:45 AM',
      value: '01:45:00',
    },
    {
      display: '02:00 AM',
      value: '02:00:00',
    },
    {
      display: '02:15 AM',
      value: '02:15:00',
    },
    {
      display: '02:30 AM',
      value: '02:30:00',
    },
    {
      display: '02:45 AM',
      value: '14:45:00',
    },
    {
      display: '03:00 AM',
      value: '03:00:00',
    },
    {
      display: '03:15 AM',
      value: '03:15:00',
    },
    {
      display: '03:30 AM',
      value: '03:30:00',
    },
    {
      display: '03:45 AM',
      value: '03:45:00',
    },
    {
      display: '04:00 AM',
      value: '04:00:00',
    },
    {
      display: '04:15 AM',
      value: '04:15:00',
    },
    {
      display: '04:30 AM',
      value: '04:30:00',
    },
    {
      display: '04:45 AM',
      value: '04:45:00',
    },
    {
      display: '05:00 AM',
      value: '05:00:00',
    },
    {
      display: '05:15 AM',
      value: '05:15:00',
    },
    {
      display: '05:30 AM',
      value: '05:30:00',
    },
    {
      display: '05:45 AM',
      value: '05:45:00',
    },
    {
      display: '06:00 AM',
      value: '06:00:00',
    },
    {
      display: '06:15 AM',
      value: '06:15:00',
    },
    {
      display: '06:30 AM',
      value: '06:30:00',
    },
    {
      display: '06:45 AM',
      value: '06:45:00',
    },
    {
      display: '07:00 AM',
      value: '07:00:00',
    },
    {
      display: '07:15 AM',
      value: '07:15:00',
    },
    {
      display: '07:30 AM',
      value: '07:30:00',
    },
    {
      display: '07:45 AM',
      value: '07:45:00',
    },
    {
      display: '08:00 AM',
      value: '08:00:00',
    },
    {
      display: '08:15 AM',
      value: '08:15:00',
    },
    {
      display: '08:30 AM',
      value: '08:30:00',
    },
    {
      display: '08:45 AM',
      value: '08:45:00',
    },
    {
      display: '09:00 AM',
      value: '09:00:00',
    },
    {
      display: '09:15 AM',
      value: '09:15:00',
    },
    {
      display: '09:30 AM',
      value: '09:30:00',
    },
    {
      display: '09:45 AM',
      value: '09:45:00',
    },
    {
      display: '10:00 AM',
      value: '10:00:00',
    },
    {
      display: '10:15 AM',
      value: '10:15:00',
    },
    {
      display: '10:30 AM',
      value: '10:30:00',
    },
    {
      display: '10:45 AM',
      value: '10:45:00',
    },
    {
      display: '11:00 AM',
      value: '11:00:00',
    },
    {
      display: '11:15 AM',
      value: '11:15:00',
    },
    {
      display: '11:30 AM',
      value: '11:30:00',
    },
    {
      display: '11:45 AM',
      value: '11:45:00',
    }
  ];
  messages: '';
  SERVER_URL: string = 'http://localhost:8080/api/';
  message: BehaviorSubject<String>;
  loadingSpinner = new BehaviorSubject(false);

  private fullName:BehaviorSubject<string> = new BehaviorSubject<string>('');
  private profilePicture:BehaviorSubject<string> = new BehaviorSubject<string>('');
  private isLoggedIn:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private userID:BehaviorSubject<string> = new BehaviorSubject<string>('');

  fullname = localStorage.getItem('fullName');
  pp = localStorage.getItem('pp');
  loggedin = localStorage.getItem('loggedIn');
  
  constructor(public http: HttpClient,public router: Router) {
    this.message = new BehaviorSubject(this.messages);
    if(this.loggedin == 'true'){
      this.updatefullName(this.fullname)
      this.updateisLoggedIn(true)
      this.updateprofilePicture(this.pp)
    }
  }
  loadingSpinnerCall(val) {
    this.loadingSpinner.next(val);
  }
  postMethod(url : string , data : any , loading : boolean ,  headers? : HttpHeaders){

    return this.http.post(`${environment.backendApi}${url}`, data , {headers}).pipe(
      map(res => {
        this.loadingSpinnerCall(loading);
        return res;
      })
    );
  }
  getMethod(url : string , loading : boolean){    
    return this.http.get(`${environment.backendApi}${url}`).pipe(
      map(res => {
        this.loadingSpinnerCall(loading);
        return res;
      })
    );
  }
  putMethod(url : string , id : string , data : any, loading : boolean, headers? : HttpHeaders){
    
    return this.http.put(`${environment.backendApi}${url}/${id}` , data, {headers}).pipe(
      map(res => {
        this.loadingSpinnerCall(loading);
        return res;
      })
    );
  }
  deleteMethod(url : string , id : string, loading : boolean ){    
    return this.http.delete(`${environment.backendApi}${url}/${id}`).pipe(
      map(res => {
        this.loadingSpinnerCall(loading);
        return res;
      })
    );
  }
  getbyIdMethod(url : string , id : string , loading : boolean ){    
    return this.http.get(`${environment.backendApi}${url}/${id}`).pipe(
      map(res => {
        this.loadingSpinnerCall(loading);
        return res;
      })
    );
  }
  logOut(){
    localStorage.clear() ; 
    this.updatefullName('')
    this.updateisLoggedIn(false) ; 
    this.updateprofilePicture('');
    window.location.reload();
    this.router.navigate(['/admin/login-form']);
  }
  playNotifyAudio(){
    let audio = new Audio();
    audio.src = "../../../assets/notication/notification.ogg";
    audio.load();
    audio.play();
  }

  getfullName(){
    return this.fullName.asObservable();
  }
  updatefullName(name){
    this.fullName.next(name);
  }

  getprofilePicture(){
    return this.profilePicture.asObservable();
  }
  updateprofilePicture(pp){
    this.profilePicture.next(pp);
  }

  getisLoggedIn(){
    return this.isLoggedIn.asObservable();
  }
  updateisLoggedIn(flag){
    this.isLoggedIn.next(flag);
  }

  getuserID(){
    return this.userID.asObservable();
  }
  updateUserId(val){
    this.userID.next(val);
  }

  nextmessage(data) {
    this.message.next(data);
  }

  getJSON(): Observable<any> {
    // return this.http.get("./assets/data.json");
    return this.patients;
  }

  update(id, status, list) {
    let filter = list.filter((a) => a.patient_id === id);
    if (filter.length != 0) {
      filter['status'] = status;
    }
  }

  getSpeciality() {
    return this.http.get(this.SERVER_URL + 'specialityList');
  }

  createSpeciality(data) {
    return this.http.post(`${this.SERVER_URL + 'specialityList'}`, data);
  }

  updateSpeciality(data, id) {
    return this.http.put(`${this.SERVER_URL + 'specialityList'}/${id}`, data);
  }

  deleteSpeciality(id) {
    return this.http.delete(`${this.SERVER_URL + 'specialityList'}/${id}`);
  }

  getDoctors() {
    return this.http.get(this.SERVER_URL + 'doctors');
  }
  getSearchDoctors() {
    return this.http.get(this.SERVER_URL + 'searchDoctor');
  }

  getDoctorDetails(id) {
    return this.http.get(`${this.SERVER_URL + 'doctors'}/${id}`);
  }

  getAppointments() {
    return this.http.get(this.SERVER_URL + 'appointments');
  }

  updateAppointment(data, id) {
    return this.http.put(`${this.SERVER_URL + 'appointments'}/${id}`, data);
  }

  getpatients() {
    return this.http.get(this.SERVER_URL + 'patients');
  }

  createBlogs(data) {
    return this.http.post(`${this.SERVER_URL + 'blogs'}`, data);
  }

  getBlogs() {
    return this.http.get(this.SERVER_URL + 'blogs');
  }

  getBlogsDetails(id) {
    return this.http.get(`${this.SERVER_URL + 'blogs'}/${id}`);
  }

  updateBlog(data, id) {
    return this.http.put(`${this.SERVER_URL + 'blogs'}/${id}`, data);
  }

  deleteBlog(id) {
    return this.http.delete(`${this.SERVER_URL + 'blogs'}/${id}`);
  }

  createDoctor(data) {
    return this.http.post(`${this.SERVER_URL + 'doctors'}`, data);
  }

  createPatient(data) {
    return this.http.post(`${this.SERVER_URL + 'patients'}`, data);
  }

  getPatientDetails(id) {
    return this.http.get(`${this.SERVER_URL + 'patients'}/${id}`);
  }

  createAppointment(params) {
    return this.http.post(`${this.SERVER_URL + 'appointments'}`, params);
  }

  getFav() {
    return this.http.get(this.SERVER_URL + 'favourites');
  }

  createFav(params) {
    return this.http.post(this.SERVER_URL + 'favourites', params);
  }

  getComments() {
    return this.http.get(this.SERVER_URL + 'comments');
  }

  createComment(params) {
    return this.http.post(this.SERVER_URL + 'comments', params);
  }

  deleteFav(id) {
    return this.http.delete(`${this.SERVER_URL + 'favourites'}/${id}`);
  }

  getTransactions() {
    return this.http.get(this.SERVER_URL + 'transactions');
  }

  deleteTransaction(id) {
    return this.http.delete(`${this.SERVER_URL + 'transactions'}/${id}`);
  }

  getReviews() {
    return this.http.get(this.SERVER_URL + 'reviews');
  }

  deleteReview(id) {
    return this.http.delete(`${this.SERVER_URL + 'reviews'}/${id}`);
  }

  getProducts() {
    return this.http.get(this.SERVER_URL + 'products');
  }

  deleteProduct(id) {
    return this.http.delete(`${this.SERVER_URL + 'products'}/${id}`);
  }

  getCategories() {
    return this.http.get(this.SERVER_URL + 'categories');
  }

  deleteCategory(id) {
    return this.http.delete(`${this.SERVER_URL + 'categories'}/${id}`);
  }

  getOrders() {
    return this.http.get(this.SERVER_URL + 'orders');
  }

  deleteOrder(id) {
    return this.http.delete(`${this.SERVER_URL + 'orders'}/${id}`);
  }

  getPharmacyReports() {
    return this.http.get(this.SERVER_URL + 'pharmacy_reports');
  }

  deletePharmacyReports(id) {
    return this.http.delete(`${this.SERVER_URL + 'pharmacy_reports'}/${id}`);
  }

  getPurchase() {
    return this.http.get(this.SERVER_URL + 'purchase');
  }

  deletePurchase(id) {
    return this.http.delete(`${this.SERVER_URL + 'purchase'}/${id}`);
  }

  getSales() {
    return this.http.get(this.SERVER_URL + 'sales');
  }

  deleteSale(id) {
    return this.http.delete(`${this.SERVER_URL + 'sale'}/${id}`);
  }
  getPharmacyTransactions() {
    return this.http.get(this.SERVER_URL + 'pharmacy_transactions');
  }

  deletePharmacyTransactions(id) {
    return this.http.delete(`${this.SERVER_URL + 'pharmacy_transactions'}/${id}`);
  }

  getPharmacy() {
    return this.http.get(this.SERVER_URL + 'pharmacy');
  }

  deletePharmacy(id) {
    return this.http.delete(`${this.SERVER_URL + 'pharmacy'}/${id}`);
  }
}
